import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { formatResumeScheduleDayOfWeek } from '@cp/entities/resume';
import { useScheduleData } from '@cp/entities/resume/model';
import { formatInterval } from '../../model';
import { ScheduleProps } from './model';

export * from './model';

const SECTION_HEIGHT = 44;

export const Schedule: React.FC<ScheduleProps> = ({ data, sx }) => {
  const theme = useTheme();
  const { sections } = useScheduleData({ data });

  if (!data) {
    return null;
  }

  return (
    <Stack
      direction="row"
      gap={{ xs: 0.5, [MOBILE_BREAKPOINT_THRESHOLD]: 1.5 }}
      sx={mergeSx(
        {
          p: 1.5,
          borderRadius: '12px',
          alignItems: 'flex-start',
          border: `1px solid ${theme.palette['gray light']}`,
          backgroundColor: theme.palette.white,
        },
        sx,
      )}
    >
      {sections.map(({ dayOfWeek, intervals }) => (
        <Box
          key={dayOfWeek}
          sx={{
            flex: '1 1 0px',
          }}
        >
          <Box
            sx={{
              height: SECTION_HEIGHT,
              backgroundColor: intervals.length ? 'gray light' : 'white',
              borderRadius: '8px',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: `1px solid ${theme.palette[intervals.length ? 'gray light' : 'gray middle']}`,
            }}
          >
            <Typography variant="caption bold">{formatResumeScheduleDayOfWeek(dayOfWeek)}</Typography>
          </Box>
          <Typography component="div" sx={{ textAlign: 'center' }} variant="small text">
            {intervals.map(formatInterval).join(', ')}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};
